import { Controller } from '@hotwired/stimulus';
import { useMatchMedia } from 'stimulus-use';

export default class extends Controller {
  initialize() {}

  connect() {
    this.initialized = true;
    useMatchMedia(this, {
      mediaQueries: {
        md: '(min-width: 992px)',
      },
    });

    this.isDesktopLayout = window.matchMedia(
      '(min-width: 992px)'
    ).matches;

    this.scrollThreshold = 100; // Define the scroll threshold in pixels
    window.addEventListener('scroll', this.onScroll.bind(this)); // Bind the scroll event
  }

  static targets = [
    'header',
    'wrapper',
    'logo',
    'hideElement',
    'layoutContainer',
    'showElement',
  ];

  static values = {
    isTransformed: Boolean,
  };

  mdChanged({ name, media, matches, event }) {
    this.isDesktopLayout = matches;
    if (!this.isDesktopLayout) {
      this.revertTransition();
    }
  }

  onScroll() {
    if (
      this.isDesktopLayout &&
      window.scrollY > this.scrollThreshold
    ) {
      this.doTransition();
    } else {
      this.revertTransition();
    }
  }

  doTransition() {
    this.transitionHeader();
    this.transitionLogo();
    this.hideElements();
    this.showElements();
  }

  transitionHeader() {
    this.wrapperTarget.style.paddingTop =
      'var(--header-transition-pt)'; // md: 12px lg:16px
    this.wrapperTarget.style.paddingBottom =
      'var(--header-transition-pb)'; // md: 10px lg:14px
    this.layoutContainerTarget.style.alignItems = 'flex-start';
    this.wrapperTarget.classList.add('shadow-light');
  }

  transitionLogo() {
    this.logoTarget.style.height = 'var(--header-logo-h)'; // md: 36px lg:40px
    this.logoTarget.parentElement.style.paddingBottom = '0px';
    const logoText = this.logoTarget.querySelector('#logo-text');
    logoText.style.opacity = '0';
  }

  hideElements() {
    this.hideElementTargets.forEach((element) => {
      element.classList.add('hidden');
    });
  }

  showElements() {
    this.showElementTargets.forEach((element) => {
      element.classList.add(element.dataset.class);
    });
  }

  revertTransition() {
    this.logoTarget.style.height = '';
    this.logoTarget.parentElement.style.paddingBottom = '';

    const logoText = this.logoTarget.querySelector('#logo-text');
    logoText.style.opacity = '';
    this.hideElementTargets.forEach((element) => {
      element.classList.remove('hidden');
    });
    this.showElementTargets.forEach((element) => {
      element.classList.remove(element.dataset.class);
    });
    this.wrapperTarget.style.paddingTop = '';
    this.wrapperTarget.style.paddingBottom = '';
    this.wrapperTarget.classList.remove('shadow-light');
    this.layoutContainerTarget.style.alignItems = '';
  }
}
